export default class ImageUpload extends HTMLElement {

  #abortController
  #imageWrap
  #image
  #slot
  #button
  #fileUrl
  input

  constructor() {
    super();
    this.NAME = 'ImageUploadInput';
    let template = `
      <style>
        :host {
          display: block;
          position: relative;
        }
        body {
          margin: 0;
        }
        main {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        [data-image-wrap] {
          width: 100%;
          height: auto;
          max-height: 240px;
          overflow: hidden;
          transition: max-height 0.5s ease-out;
          position: relative;

          img {
            width: 100%;
            height: auto;
            max-height: 240px;
            object-fit: contain;
            display: block;
          }
        }
        [data-image-wrap][data-reveal="false"] {
          max-height: 0px;
        }
        slot[name="input"] {
          display: block;
          max-height: 45px;
          overflow: hidden;
          transition: max-height 0.3s ease-out;
        }
        slot[name="input"][data-reveal="false"] {
          max-height: 0px;
        }
        button {
          width: 32px;
          height: 32px;
          border: none;
          background-color: rgb(255,255,255);
          border-radius: 50%;
          position: absolute;
          top: 8px;
          right: 8px;
        }
      </style>
      <main>
        <slot name="input" data-reveal="true"></slot>
        <div data-image-wrap data-reveal="false">
          <img src width="100" height="100" loading="lazy">
          <button>
            <slot name="icon"></slot>
          </button>
        </div>
      </main>
    `;
    let templateDoc = new DOMParser().parseFromString(template, "text/html");
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.appendChild(templateDoc.documentElement);
    this.#imageWrap = this.shadowRoot.querySelector('[data-image-wrap]');
    this.#image = this.shadowRoot.querySelector('img');
    this.#slot = this.shadowRoot.querySelector('slot[name="input"]');
    this.#button = this.shadowRoot.querySelector('button');
    this.input = this.querySelector('input');
  }

  connectedCallback() {
    this.#abortController = new AbortController()
    const { signal } = this.#abortController;
    //
    this.input.addEventListener('change', (e) => {
      const file = e.target.files[0];
      this.#fileUrl = URL.createObjectURL(file);
      this.#image.src = this.#fileUrl;
      this.#imageWrap.dataset.reveal = 'true';
      this.#slot.dataset.reveal = 'false';
    }, { signal });
    //
    this.#button.addEventListener('click', () => {
      this.input.value = '';
      this.#imageWrap.dataset.reveal = 'false';
      this.#slot.dataset.reveal = 'true';
    }, { signal })
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = null;
    if (this.#fileUrl) URL.revokeObjectURL(this.#fileUrl);
  }

}

customElements.define('image-upload', ImageUpload);